module.exports = __webpack_public_path__ + "img/furgoneWhite.29990209.svg";